export default __webpack_public_path__ + "static/media/page-not-found-dark.6ee7ff45.svg";